import { render, staticRenderFns } from "./HealthInstitutionDailyAttention.vue?vue&type=template&id=062267fd&"
import script from "./HealthInstitutionDailyAttention.vue?vue&type=script&lang=js&"
export * from "./HealthInstitutionDailyAttention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports